import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { SIZE } from "../../constants/size.js";
import { THEME } from "../../constants/theme.js";
import { cn as clsx } from "../../helpers/react.js";
import { legacyTypoMapping } from "./legacyTypoMapping.js";
import { typoMapping } from "./typoMapping.js";
import '../../assets/index6.css';const dark = "_dark_qi3xw_2";
const light = "_light_qi3xw_79";
const standardSize = "_standardSize_qi3xw_156";
const compactSize = "_compactSize_qi3xw_193";
const extendedSize = "_extendedSize_qi3xw_230";
const semanticCritical = "_semanticCritical_qi3xw_267";
const semanticWarning = "_semanticWarning_qi3xw_282";
const semanticSuccess = "_semanticSuccess_qi3xw_297";
const semanticInfo = "_semanticInfo_qi3xw_312";
const s = {
  dark,
  light,
  standardSize,
  compactSize,
  extendedSize,
  semanticCritical,
  semanticWarning,
  semanticSuccess,
  semanticInfo
};
const finalTypoMapping = {
  ...legacyTypoMapping,
  ...typoMapping
};
const SEMANTIC_CLASS_NAME_MAP = {
  critical: s.semanticCritical,
  warning: s.semanticWarning,
  success: s.semanticSuccess,
  info: s.semanticInfo
};
const THEME_CLASS_NAME_MAP = {
  [THEME.DARK]: s.dark,
  [THEME.LIGHT]: s.light,
  [THEME.CUSTOM]: ""
};
const SIZE_CLASS_NAME_MAP = {
  [SIZE.STANDARD]: s.standardSize,
  [SIZE.EXTENDED]: s.extendedSize,
  [SIZE.COMPACT]: s.compactSize
};
const getTypographyClassName = (typo) => {
  return typo ? finalTypoMapping[typo] ?? "" : "";
};
const getSemanticClassName = (semantic) => {
  return semantic ? SEMANTIC_CLASS_NAME_MAP[semantic] : "";
};
const getThemeClassName = (theme) => {
  return theme ? THEME_CLASS_NAME_MAP[theme] : "";
};
const getSizeClassName = (size) => {
  return size ? SIZE_CLASS_NAME_MAP[size] : "";
};
const _AirfoilStyles = forwardRef((props, ref) => {
  const { children, typo, semantic, theme, size } = props;
  return /* @__PURE__ */ jsx(
    Slot,
    {
      ref,
      className: clsx(
        getTypographyClassName(typo),
        getSemanticClassName(semantic),
        getThemeClassName(theme),
        getSizeClassName(size)
      ),
      children
    }
  );
});
const AirfoilStyles = Object.assign(_AirfoilStyles, {
  /**
   * Returns the CSS class name for a given typography token
   */
  getTypographyClassName,
  /**
   * Returns the CSS class name for a given semantic token
   */
  getSemanticClassName,
  /**
   * Returns the CSS class name for a given theme token
   */
  getThemeClassName,
  /**
   * Returns the CSS class name for a given size token
   */
  getSizeClassName
});
const AS = AirfoilStyles;
export {
  AS,
  AirfoilStyles,
  SEMANTIC_CLASS_NAME_MAP,
  SIZE_CLASS_NAME_MAP,
  THEME_CLASS_NAME_MAP,
  finalTypoMapping
};
